// Gates v2 helpers shared by order form, sheet sizes, costing and the rate chart.
export const SIZE_UNITS = [
  { key: "inch", label: "inch" },
  { key: "ft", label: "ft" },
  { key: "mm", label: "mm" },
];

export const GATE_V2_STAGES = [
  { v: "new_order", label: "New Order" },
  { v: "framing_making", label: "Framing Making" },
  { v: "sheet_size_pending", label: "Upload Sheet Size" },
  { v: "design_making", label: "Design Making" },
  { v: "ready_to_cut", label: "Ready for Cutting" },
  { v: "design_cutting", label: "Design Cutting" },
  { v: "ready_for_installation", label: "Ready for Installation" },
  { v: "completed", label: "Ready for Delivery" },
  { v: "delivered", label: "Delivered" },
];

export const toIn = (val, unit) => {
  const n = Number(val) || 0;
  if (unit === "mm") return Math.round((n / 25.4) * 10000) / 10000;
  if (unit === "ft") return n * 12;
  return n;
};

export const n3 = (v) => Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 3 });
export const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const typesOf = (rows) => {
  const seen = new Map();
  rows.filter((r) => r.active).forEach((r) => { if (!seen.has(r.type_key)) seen.set(r.type_key, r.type_label); });
  return Array.from(seen, ([key, label]) => ({ key, label }));
};

export const subsOf = (rows, typeKey) => rows.filter((r) => r.active && r.type_key === typeKey && r.sub_key);

export const rowFor = (rows, typeKey, subKey) =>
  rows.find((r) => r.active && r.type_key === typeKey && (r.sub_key || "") === (subKey || ""));

export const workItemName = (wi) =>
  [wi.label || wi.type_label, wi.sub_label, wi.thickness_mm ? `${wi.thickness_mm}mm plate` : ""].filter(Boolean).join(" · ");

// Pick the sheet item for a plate thickness: "2.5mm Sheet" for 2.5, never "2.5mm" for 2.
export const pickPlateItem = (plateItems, mm) => {
  if (!mm) return "";
  const re = new RegExp(`(^|[^0-9.])${String(mm).replace(".", "\\.")}\\s*mm`, "i");
  const hit = plateItems.find((p) => re.test(` ${p.thickness || ""} ${p.name || ""}`));
  return hit ? hit.id : "";
};
